const state = {
  orderId: null,
  productKey: null,
  parentPoId: null,
  targetPortalRootLink: ''
};

const getters = {
  productKey: (state) => state.productKey,
  orderId: (state) => state.orderId,
  parentPoId: (state) => state.parentPoId,
  targetPortalRootLink: (state) => state.targetPortalRootLink
};

const mutations = {
  SET_ORDER_ID(state, orderId) {
    state.orderId = orderId;
  },
  SET_PARENT_PO_ID(state, parentPoId) {
    state.parentPoId = parentPoId;
  },
  SET_PRODUCT_KEY(state, key) {
    state.productKey = key;
  },
  SET_TARGET_PORTAL_ROOT_LINK(state, portalRootLink) {
    state.targetPortalRootLink = portalRootLink;
  }
};

export default {
  state,
  getters,
  mutations
};
